import actions from "./actions";

const initState = {
  courses: null,
  coursesPublished: null,
  units: null,
  teachers: null,
  classroomTeachers: null,
  students: null,
  decryptedPath: null,
  key: null,
  course: null, // Added course since you set it in some cases
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_COURSES_SUCCESS:
      return {
        ...state,
        courses: action.courses,
      };
    case actions.FETCH_PUBLISHED_COURSES_SUCCESS:
      return {
        ...state,
        coursesPublished: action.coursesPublished,
      };
    case actions.FETCH_UNIT_DETAILS_SUCCESS:
      return {
        ...state,
        units: action.units,
      };
    case actions.FETCH_TEACHERS_SUCCESS:
      return {
        ...state,
        teachers: action.teachers,
      };
    case actions.FETCH_COURSE_DETAILS_SUCCESS:
    case actions.ADD_EXISTING_COURSE_SUCCESS:
    case actions.EDIT_SINGLE_COURSE_SUCCESS:
    case actions.DELETE_SINGLE_COURSE_FILE_SUCCESS:
      return {
        ...state,
        course: action.course,
      };
    case actions.FETCH_CLASSROOM_STUDENTS_SUCCESS:
      return {
        ...state,
        students: action.students,
      };
    case actions.FETCH_CLASSROOM_TEACHERS_SUCCESS:
      return {
        ...state,
        classroomTeachers: action.classroomTeachers,
      };
    case actions.GET_FILE_SUCCESS:
      return {
        ...state,
        decryptedPath: action.decryptedPath,
      };
    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };
    case actions.RESET:
      return {
        ...state,
        courses: null,
      };
    default:
      return state;
  }
}
